import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Stack, Grid, Typography, TextField, CardActions, } from '@mui/material';
import { Button, Alert } from '@mui/material';
import { Card, CardContent, ToggleButtonGroup, ToggleButton } from '@mui/material';

import { pb } from '../utilities/pocketbase';

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function Login() {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState("")
    const [sendRequest, setSendRequest] = useState(false)
    const [userType, setUserType] = useState('examinee');
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })

    useEffect(() => {
        function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            })
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })

    const navigate = useNavigate();

    const handleUserType = (event, newUserType) => {
        setUserType(newUserType);
    };

    const handleUsername = (e) => {
        setUsername(e.target.value)
    }

    const handlePassword = (e) => {
        setPassword(e.target.value)
    }

    useEffect(() => {
        window.document.title = 'Login'
        return () => { window.document.title = process.env.REACT_APP_NAME }
    }, [])

    useEffect(() => {
        if (sendRequest && username && password) {
            setError("")
            pb.collection(`${userType}s`).authWithPassword(username, password).then(record => {
                // console.log("login record:", record)
                // console.log(pb.authStore.isValid);
                // console.log(pb.authStore.token);
                console.log(pb.authStore.model.id);
                navigate('/')
            }).catch(error => {
                console.log("login error:", error)
                setError(error?.message)
            }).finally(() => setSendRequest(false))
        }
    }, [sendRequest, username, password, userType, navigate])

    return (
        <Grid container justifyContent={"center"} alignItems={"center"} height={dimensions?.height - 300}>
            <Grid item xs={12} sm={12} md={6} lg={4}>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant='h4' align='center' fontFamily={"JetBrains Mono"}>LOGIN</Typography>
                        <ToggleButtonGroup
                            value={userType}
                            exclusive
                            onChange={handleUserType}
                            fullWidth
                        >
                            <ToggleButton value="examinee" color='info' sx={{ py: 2 }}>
                                Examinee
                            </ToggleButton>
                            {/* <ToggleButton value="finalist" color='success' sx={{ py: 2 }}>
                                Finalist
                            </ToggleButton> */}
                            <ToggleButton value="supervisor" color='warning' sx={{ py: 2 }}>
                                Supervisor
                            </ToggleButton>
                        </ToggleButtonGroup>
                        <TextField fullWidth value={username} onChange={handleUsername} label={"username"} />
                        <TextField fullWidth value={password} onChange={handlePassword} label={"password"} type='password' onKeyDown={(e) => { e.key === "Enter" && setSendRequest(true) }} />
                        <Stack spacing={1} sx={{ px: 0 }}>
                            <Button onClick={() => setSendRequest(true)} variant="contained" size="large" endIcon={<ArrowForwardIcon />} className='shadow' sx={{ py: 2 }} fullWidth>Login</Button>
                            <Button size="large" startIcon={<ArrowBackRoundedIcon />} className='shadow' sx={{ py: 2 }} fullWidth component={Link} to={"/"}>Back</Button>
                        </Stack>
                        {error && <Alert severity='error' sx={{ justifyContent: "center", alignItems: "center" }}>{error}</Alert>}
                    </Stack>
                </CardContent>
            </Grid>
        </Grid>
    )
}